import { createCustomEvent } from "../../../../javascript/shared/helpers"

export default class extends Controller {
  static targets = ["toggleSetting"]

  switchTo(event) {
    const target = event.currentTarget
    const { contentTitle, contentUrl: contentURL } = target.dataset
    this.toggleSettingTargets.forEach(toggle => {
      toggle.classList[toggle === target ? "add" : "remove"]("is-active")
    })
    document.dispatchEvent(createCustomEvent("primary-content-pane-load:trigger", this.element, { contentURL, contentTitle }))
  }
}



// WEBPACK FOOTER //
// ./app/components/buttons/assets/javascript/buttons-content-type-toggle-button-controller.js